import { render } from "./Navbar31View.vue?vue&type=template&id=df52662a"
const script = {}

import exportComponent from "E:\\2023-1\\sukun\\Sukun-Psikotes-FE-Peserta\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__